<template>
  <div class="account-edit">
    <table class="account-edit__table" v-if="isLoggedIn">
      <tr class="account-edit__row">
        <th class="account-edit__title">メールアドレス</th>
        <td class="account-edit__data">
          <a href="/user/account/email" class="account-edit__link">
            {{ userInfo.email || '未設定' }}
          </a>
        </td>
      </tr>
      <tr class="account-edit__row">
        <th class="account-edit__title">パスワード</th>
        <td class="account-edit__data">
          <a href="/user/account/password/confirm" class="account-edit__link">
            ●●●●●●●●●●
          </a>
        </td>
      </tr>
      <tr class="account-edit__row">
        <th class="account-edit__title">SNS連携</th>
        <td class="account-edit__data">
          {{ relationSnsName || '未連携' }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'
import fetchAccountData from '@/utils/fetchAccountData'
import firebaselogin from '../firebaselogin'

export default {
  name: 'account-edit',
  mixins: [firebaselogin],
  data() {
    return {
      token: window.Laravel.csrfToken,
      loadingData: false,
      accountData: [],
      relationSnsName: this.relationSns,
    }
  },
  props: {
    relationSns: String,
  },
  computed: {
    ...mapState({
      accessToken: state => state.auth.accessToken,
      userInfo: state => state.account.user
    }),
    ...mapGetters(['isLoggedIn']),
  },
  mounted() {
    if (this.isLoggedIn) {
      this.getUserProfile()
    }
  },
  methods: {
    getUserProfile() {
      if (this.accessToken) {
        this.$store.dispatch(type.GET_ACCOUNT, this.accessToken)
        // fetchAccountData.getProfile(this.accessToken).then(res => {
        //   this.accountData = res
        //   console.log(this.accountData);
        //   this.$nextTick(function () {
        //     this.loadingData = true
        //   })
        // })
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../sass/commons/commonVariables.scss';

.account-edit {
  margin: 0 -16px;
  &__table {
    width: 100%;
    border-collapse: collapse;
    border: none;
    border-spacing: 0px;
  }
  &__row {}
  &__title,
  &__data {
    margin: 0;
    line-height: 1.2;
    border-bottom: 1px solid $col_temp_gray3;
    vertical-align: middle;
    text-align: left;
  }
  &__title {
    width: 32%;
    padding: 16px 10px 16px 20px;
    font-size: 12px;
    font-weight: 400;
    color: $col_normal_font;
  }
  &__data {
    padding: 16px 40px 16px 0;
    font-size: 14px;
    color: $col_base_black;
  }
  &__link {
    display: block;
    position: relative;
    text-decoration: none;
    word-break: break-all;
    &::after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      right: -26px;
      width: 24px;
      height: 24px;
      margin: auto;
      background: url("/static/img/common/arrow_right.svg") no-repeat 50% 50%/contain;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/User/AccountEdit.vue